module.exports = __webpack_public_path__ + "img/sortimentsverwaltung-aktiv.2e2d023b.svg";